module.exports = __webpack_public_path__ + "img/03.414ba9c4.jpg";